/**
 * 园区监控 store
 */

import axios from "../../utils/axios";

let state = {
  monitorList: []
};

let getters = {
  getMonitorList(state) {
    return state.monitorList;
  }
};

let mutations = {
  setMonitorList(state, payload) {
    state.monitorList = payload.monitorList;
    // console.log(state.monitorList);
  }
};

let actions = {
  monitorList(context, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`/camera?room_id=${payload.roomId}`)
      .then(res => {
        // console.log(res);
        if (res.status === 200) {
          resolve(res.data.data);
        }
      })
      .catch(error => {
        console.log(error);
        reject();
      });
    });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
}